import React from 'react';

import { studioTheme } from './studioTheme';
import {
  StudioWrap,
  Avatar,
  Identity,
  SourceLogo,
  Stars,
  DateText,
} from './StudioCardKit';
import { StudioBody, isMediaTestimonial, StudioMediaCard } from './StudioBody';

/**
 * Prism Edge (widget type 16)
 *
 * An otherwise plain card wrapped in a one-pixel conic-gradient border. The
 * cheapest way to make a wall look considered, and the gradient picks up the
 * wall's quotation and rating colours so it still reads as the customer's.
 */
const PrismEdgeCard = (props) => {
  const { cardItem, socialCardType } = props;
  const t = studioTheme(props);

  const base = t.dark ? '#151821' : '#ffffff';
  const surface = (t.cardBackgroundObject && t.cardBackgroundObject.backgroundColor) || base;

  const ring = `conic-gradient(from 180deg, ${t.accent}, ${t.brand}, ${t.link}, ${t.accent})`;

  /* One body type scale per card: the text testimonial and the video/audio
     summary must read as the same widget. */
  const bodyTextStyle = { fontSize: t.smallSize ? 14 : 14.5, lineHeight: 1.55 };

  /* A video or audio testimonial IS the card - the player already carries
     the name and work title, so none of the chrome below is drawn. Only the
     summary keeps this widget's look, as the panel it extends into. */
  if (isMediaTestimonial(cardItem, socialCardType)) {
    return (
      <StudioMediaCard
        cardItem={cardItem}
        socialCardType={socialCardType}
        t={t}
        enclosure={{
          /* the gradient edge is the whole point of this type, so wrap the player even with no summary. */
          always: true,
          border: '1px solid transparent',
          borderRadius: 16,
          background: `linear-gradient(${surface},${surface}) padding-box, ${ring} border-box`,
          boxShadow: t.shadow,
        }}
        summaryStyle={bodyTextStyle}
      />
    );
  }

  return (
    <StudioWrap>
      <div
        style={{
          position: 'relative',
          borderRadius: 16,
          padding: 1,
          background: ring,
          boxShadow: t.shadow,
        }}
      >
        <div
          style={{
            position: 'relative',
            borderRadius: 15,
            padding: 18,
            display: 'flex',
            flexDirection: 'column',
            gap: 12,
            background: surface,
            ...(t.cardBackgroundObject || {}),
          }}
        >

          <div style={{ display: 'flex', alignItems: 'center', gap: 10, minWidth: 0 }}>
            <Avatar cardItem={cardItem} size={40} />
            <div style={{ flex: 1, minWidth: 0 }}>
              <Identity t={t} cardItem={cardItem} />
            </div>
            <SourceLogo cardItem={cardItem} />
          </div>

          <Stars t={t} cardItem={cardItem} size={13} />

          <StudioBody
            t={t}
            cardItem={cardItem}
            socialCardType={socialCardType}
            textStyle={bodyTextStyle}
          />

          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              gap: 10,
              flexWrap: 'wrap',
            }}
          >
            <DateText t={t} cardItem={cardItem} />
          </div>
        </div>
      </div>
    </StudioWrap>
  );
};

export default PrismEdgeCard;
